import SadStory from './sadStory.js'
import DinnerEnding from './dinnerEnding.js';
import GoodEnding from './goodEnding.js';
import LetItGo from './letItGo.js';
import BadEnding from './badEnding.js';

export default [
    {
        characterImg: `unset`,
        speakerName: `unset`,
        speakerTxt: `[Couple of hours later ...]`,
        speakerTxtRS: `[Par sati kasnije ...]`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `It took me several hours to write a new feature for this insurance company in Africa and another couple of hours to fix the bugs they detected.`,
        speakerTxtRS: `Bilo mi je potrebno nekoliko sati da napišem kod za onu kompaniju za osiguranje u Africi i još par sati da otklonim greške koje su otkrili.`,
        dialogFx: `assets/dialog/joseph/joseph0037.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/parkingLot.webp`,
        speakerName: `unset`,
        speakerTxt: ` `
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"Joseph, thank God you're here."`,
        speakerTxtRS: `"Jožef, hvala Bogu da si tu."`,
        characterImg: `assets/chars/millie/neutral.webp && assets/chars/anna/frown.webp`,
        dialogFx: `assets/dialog/millie/millie0013.mp3`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Why are they here? It's late. Past office hours.`,
        speakerTxtRS: `Zašto su ovde? Kasno je. Posle radnog vremena.`,
        dialogFx: `assets/dialog/joseph/joseph0038.mp3`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"You girls haven't left yet?"`,
        speakerTxtRS: `"Još uvek niste otišle?"`,
        dialogFx: `assets/dialog/joseph/joseph0039.mp3`,
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"Anna's car broke. We tried contacting a friend but he didn't show up. Thought, perhaps you could give us a ride."`,
        speakerTxtRS: `"Anin auto se pokvario. Pokušali smo da kontaktiramo prijatelja, ali se ne pojavljuje. Da li bi mogao da nas povezeš."`,
        dialogFx: `assets/dialog/millie/millie0014.mp3`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Sure, get in."`,
        speakerTxtRS: `"Naravno, updajte."`,
        dialogFx: `assets/dialog/joseph/joseph0040.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/wayhome.webp`,
        characterImg: `unset`,
        speakerTxt: `"Where does Anna live?"`,
        speakerTxtRS: `"Gde živi Ana?"`,
        dialogFx: `assets/dialog/joseph/joseph0041.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"With me. We are roommates."`,
        speakerTxtRS: `"Samnom. Cimerke smo."`,
        dialogFx: `assets/dialog/millie/millie0015.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `She lives with Millie. What a nightmare.`,
        speakerTxtRS: `Ona živi sa Milicom. Koja noćna mora.`,
        dialogFx: `assets/dialog/joseph/joseph0042.mp3`
    },
    {
        speakerTxt: `sigh.`,
        speakerTxtRS: `uzdah.`,
        dialogFx: `assets/dialog/joseph/joseph0043.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        characterImg: `unset`,
        speakerName: `unset`,
        speakerTxt: `[That night, 9:00 pm ...]`,
        speakerTxtRS: `[Te noći, 21:00 ...]`
    },
    {
        backgroundImg: `assets/bgImgs/diary.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `My heart pounded a little faster today. A human existence felt different for the first time in my life. I wanted to stay, I wanted to take a longer route and hear her speak. Yet she doesn't speak much.`,
        speakerTxtRS: `Moje srce je kucalo brže danas. Ljudsko postojanje u mom životu se prvi put osećalo drugačije. Hteo sam da ostanem, hteo sam da idem dužom putanjom i da je čujem kako govori. Ipak, ona ne govori mnogo.`,
        dialogFx: `assets/dialog/joseph/joseph0044.mp3`
    },
    {
        speakerTxt: `She smiles all the time yet her big brown eyes tell a different story. When she smiled in the backseat, my heart skipped a beat. I wish I could make an app to pause time at least for a second of it.`,
        speakerTxtRS: `Ona se sve vreme smeje, ali njene velike smeđe oči govore drugu priču. Kada se osmehnula na zadnjem sedištu, srce mi je preskočilo. Voleo bih da mogu da napravim aplikaciju da pauziram vreme barem na sekundu.`,
        dialogFx: `assets/dialog/joseph/joseph0045.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        speakerTxt: `[Couple of days later ...]`,
        speakerTxtRS: `[Nekoliko dana kasnije ...]`
    },
    {
        backgroundImg: `assets/bgImgs/JosephOffice.webp`,
        speakerTxt: `[knock, knock, knock ...]`,
        speakerTxtRS: `[kuc, kuc, kuc ...]`,
        soundFx: `assets/sounds/knocking-on-the-door.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Come in, please."`,
        speakerTxtRS: `"Napred."`,
        dialogFx: `assets/dialog/joseph/joseph0046.mp3`
    },
    {
        speakerTxt: `I need to act normal. Being cold and grumpy is my normal. I don't have to let her know that her appearance shines my heart like a star-lit sky.`,
        speakerTxtRS: `Moraću da se ponašam normalno. Biti hladan i namćor je moja normalnost. Ne moram da zna da njen izgled osvetljava moje srce kao nebo puno zvezda.`,
        dialogFx: `assets/dialog/joseph/joseph0047.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"I have been meaning to talk about the company's website."`,
        speakerTxtRS: `"Imala sam namjeru da pričam o veb sajtu kompanije."`,
        dialogFx: `assets/dialog/anna/anna0010.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `She has the voice of a nightingale. Only that, I have no desire to be the king who kept it. I want the nightingale forever.`,
        speakerTxtRS: `Ona ima glas slavuja. Samo, nemam želju da budem kralj koji je sakrivao. Želim slavuja zauvek. `,
        dialogFx: `assets/dialog/joseph/joseph0048.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Benjamin told me that the website has lost its traffic. I have gone through articles, particularly those about AI and JavaScript. They are not kind of Search Engine Optimized. Most of them are AI generated. Some of the articles have 80% plagiarism."`,
        speakerTxtRS: `"Bojan mi je rekao da je sajt izgubio posetioce. Prošla sam kroz članke, posebno one o AI i JavaScript. Nisu optimizovani za pretraživače. Većina je generisana AI-om. Neki od članaka imaju 80% plagijata."`,
        dialogFx: `assets/dialog/anna/anna0011.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `I like her even more. She has brains, beauty and brown eyes. She's the death of me!`,
        speakerTxtRS: `Još više mi se sviđa. Ona ima mozak, lepotu i smeđe oči. Ona je moja smrt!`,
        dialogFx: `assets/dialog/joseph/joseph0049.mp3`
    },
    {
        speakerTxt: `"Impressive."`,
        speakerTxtRS: `"Impresivno."`,
        dialogFx: `assets/dialog/joseph/joseph0050.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"I have been working on it since last week."`,
        speakerTxtRS: `"Radila sam na tome od prošle nedelje."`,
        dialogFx: `assets/dialog/anna/anna0012.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"You're great Anna. Would you rewrite the articles or write new ones?"`,
        speakerTxtRS: `"Ti si odlična Ana. Da li bi ponovo napisala članke ili napisala nove?"`,
        dialogFx: `assets/dialog/joseph/joseph0051.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"I have rewritten some and wrote new ones also."`,
        speakerTxtRS: `"Napisala sam neke ponovo i napisala sam nove takođe."`,
        dialogFx: `assets/dialog/anna/anna0013.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Unbelievable! Where did you learn to write? Its mind blowing!"`,
        speakerTxtRS: `"Neverovatno! Gde si naučila da pišeš? Ovo je neverovatno!"`,
        dialogFx: `assets/dialog/joseph/joseph0052.mp3`
    },
    {
        speakerTxt: `She is mind blowing. To be honest, I didn't read more than two lines. I couldn't read. I can barely breathe in front of her.`,
        speakerTxtRS: `Ona je neverovatna. Iskreno, nisam pročitao više od dve linije. Nisam mogao da čitam. Teško mi je disati pred njom.`,
        dialogFx: `assets/dialog/joseph/joseph0053.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"Gramercy."`,
        dialogFx: `assets/dialog/anna/anna0014.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `She reads Shakespeare. I need to ask her.`,
        speakerTxtRS: `Ona čita Šekspira. Moram da je pitam.`,
        dialogFx: `assets/dialog/joseph/joseph0054.mp3`
    },
    {
        speakerTxt: `"You read Shakespeare, don't you?"`,
        speakerTxtRS: `"Ti čitaš Šekspira, zar ne?"`,
        dialogFx: `assets/dialog/joseph/joseph0055.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/blushSmile.webp`,
        speakerTxt: `"Sounds like I'm not the only book fanatic."`,
        speakerTxtRS: `"Zvuči kao da nisam jedini fanatičar knjiga."`,
        dialogFx: `assets/dialog/anna/anna0015.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `I registered! I like her.`,
        speakerTxtRS: `Prihvatam! Sviđa mi se.`,
        dialogFx: `assets/dialog/joseph/joseph0056.mp3`
    },
    {
        speakerTxt: `"Want to grab a coffee?"`,
        speakerTxtRS: `"Hoćeš li da zgrabimo kafu?"`,
        dialogFx: `assets/dialog/joseph/joseph0057.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"I would love to."`,
        speakerTxtRS: `"Volela bi to."`,
        dialogFx: `assets/dialog/anna/anna0016.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        characterImg: `unset`,
        speakerName: `unset`,
        speakerTxt: `[Nearby coffee bar ...]`,
        speakerTxtRS: `[Obližnji kafić ...]`,
        soundFx: `assets/sounds/shopDoorBell.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/coffeeShop.webp`,
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"Let me guess, your current read is The Diary of a Young Girl?"`,
        speakerTxtRS: `"Da pogodim, trenutno čitač Dnevnik Ane Frank?"`,
        dialogFx: `assets/dialog/anna/anna0017.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `She is interesting, but this is not something like she cracked a code. She saw me reading in my office.`,
        speakerTxtRS: `Ona je zanimljiva, ali nije kao da je razbila kod. Videla me je kako čitam u svojoj kancelariji.`,
        dialogFx: `assets/dialog/joseph/joseph0058.mp3`
    },
    {
        speakerTxt: `"Yes."`,
        speakerTxtRS: `"Da."`,
        dialogFx: `assets/dialog/joseph/joseph0059.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/surprised.webp`,
        speakerTxt: `"Why? I mean it's not your thing. You sound like a misogynist."`,
        speakerTxtRS: `"Zašto? Mislim da nije tvoja stvar. Zvučiš kao misogen."`,
        dialogFx: `assets/dialog/anna/anna0018.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `I don't hate women. I only hate women I know. They brought disappointment to my life. They thrashed my joy and robbed my peace. I fear to hope. They threw me in the pits of loneliness where I stayed long enough to be comfortable with aching solitude.`,
        speakerTxtRS: `Ne mrzim žene. Mrzim samo žene koje poznajem. One su donosile razočaranje u moj život. Oni su mi razbijali radost i opljačkali moj mir. Bojim se da se nadam. Oni su me bacili u dubine usamljenosti gde sam proveo dovoljno dugo da budem ugodan sa bolom usamljenosti.`,
        dialogFx: `assets/dialog/joseph/joseph0060.mp3`
    },
    {
        speakerTxt: `"No, I am not."`,
        speakerTxtRS: `"Ne, nisam."`,
        dialogFx: `assets/dialog/joseph/joseph0061.mp3`
    },
    {
        speakerTxt: `That's all I could utter. I wish I could say everything that replays in my mind, over and over. I wish I could tell her that I am not over the pain my mother inflicted. I wish I could tell her that how she cheated on my loving, enormously rich father behind his back with a salesman from the near store.`,
        speakerTxtRS: `To je sve što sam uspeo izreći. Želeo bi da mogu da kažem sve što mi se stalno ponavlja u glavi. Želeo bi da joj kažem da nisam prešao preko bola koju mi je mama nanela. Želeo bi da joj kažem kako je varala mog brižnog i bogatog oca iza njegovih leđa, sa prodavcem iz obližnje prodavnice.`,
        dialogFx: `assets/dialog/joseph/joseph0062.mp3`
    },
    {
        speakerTxt: `"Anyway, how did you end up here? Why did you abandon such an elite profession?"`,
        speakerTxtRS: `"Inače, kako si završila ovde, Zašto si napustila tako elitnu profesiju?"`,
        dialogFx: `assets/dialog/joseph/joseph0063.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/sad.webp`,
        speakerTxt: `"Long story."`,
        speakerTxtRS: `"Dugačka priča."`,
        dialogFx: `assets/dialog/anna/anna0019.mp3`
    },
    {
        speakerTxt: `...`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `...`,
    },
    {
        speakerTxt: `"Who are your favorite writers?"`,
        speakerTxtRS: `"Koji su tvoji omiljeni pisci?"`,
        dialogFx: `assets/dialog/joseph/joseph0064.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"I like to read books by Jane Austen and Charles Dickens. I love how both of them could capture the nuances of everyday life and relationships so accurately. Jane Austen's books are full of wit and charm, while Charles Dickens' stories are incredibly vivid and imaginative."`,
        speakerTxtRS: `"Volim da čitam knjige Jane Austen i Čarles Dikens. Volim kako su mogli da uhvate nijanse svakodnevnog života i odnosa tako precizno. Knjige Jane Austen su puni duha i šarma, dok su priče Čarls Dikensa neverovatno žive i maštovite."`,
        dialogFx: `assets/dialog/anna/anna0020.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Absolutely, they are both amazing writers. I really enjoy the works of Fyodor Dostoevsky. His stories explore such deep themes of morality, faith, and redemption."`,
        speakerTxtRS: `"Potpuno, oba su neverovatni pisci. Ja uživam u radovima Fjodora Dostojevskog. Njegove priče istražuju tako duboke teme moralnosti, vere i otkupljenja."`,
        dialogFx: `assets/dialog/joseph/joseph0065.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Have you heard about the new book The Morality of Man that's out?"`,
        speakerTxtRS: `"Da li si čuo za novu knjigu Morala čoveka koja je izašla?"`,
        dialogFx: `assets/dialog/anna/anna0021.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"No, I haven't. What's it about?"`,
        speakerTxtRS: `"Ne, nisam. O čemu je?"`,
        dialogFx: `assets/dialog/joseph/joseph0066.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"It's about a man who discovers that morality is not absolute and that it can be influenced by different factors. He also learns that morality is a matter of personal choice and that no one should be judged for the choices they make."`,
        speakerTxtRS: `"O čoveku koji otkriva da moral nije apsolutan i da se može uticati na različite faktore. On takođe nauči da je moral pitanje ličnog izbora i da niko ne bi trebalo da bude osuđen za izbore koje donosi."`,
        dialogFx: `assets/dialog/anna/anna0022.mp3`
    },
    {
        speakerTxt: `"He ultimately concludes that the most important thing is to act with integrity and to treat others with respect."`,
        speakerTxtRS: `"On na kraju zaključi da je najvažnije da se ponaša sa integritetom i da tretira druge sa poštovanjem."`,
        dialogFx: `assets/dialog/anna/anna0023.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"That sounds like a very interesting book. I'll definitely check it out."`,
        speakerTxtRS: `"Zvuči kao veoma interesantna knjiga. Sigurno ću je pročitati."`,
        dialogFx: `assets/dialog/joseph/joseph0067.mp3`
    },
    {
        speakerTxt: `I take a deep breath.`,
        speakerTxtRS: `Uzeo sam duboki udah.`,
        dialogFx: `assets/dialog/joseph/joseph0068.mp3`
    },
    {
        speakerTxt: `"There is a restaurant in the next street. They make the best dishes in town."`,
        speakerTxtRS: `"U obližnjoj ulici postoji restoran. Oni prave najbolja jela u gradu."`,
        dialogFx: `assets/dialog/joseph/joseph0069.mp3`
    },
    {
        speakerTxt: `I have no slightest idea how to ask for a date.`,
        speakerTxtRS: `Nemam ni najmanju ideju kako da pitam za izlazak.`,
        dialogFx: `assets/dialog/joseph/joseph0070.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Is Joseph the giant arrogant asking just Anna out?"`,
        speakerTxtRS: `"Je li to Jožef arogantni pita samo Anu da izađe?"`,
        dialogFx: `assets/dialog/anna/anna0024.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"I am not asking for a date!"`,
        speakerTxtRS: `"Ne pitam za izlazak!"`,
        dialogFx: `assets/dialog/joseph/joseph0071.mp3`
    },
    {
        speakerTxt: `I lied.`,
        speakerTxtRS: `Lažem.`,
        dialogFx: `assets/dialog/joseph/joseph0072.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"Just dinner. I get it."`,
        speakerTxtRS: `"Samo večera. Razumem."`,
        dialogFx: `assets/dialog/anna/anna0025.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        characterImg: `assets/chars/anna/closedSmile.webp && assets/chars/millie/teethSmile.webp`,
        speakerTxt: `"Someone is getting along well."`,
        speakerTxtRS: `"Neko se dobro slaže."`,
        dialogFx: `assets/dialog/millie/millie0016.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmile.webp && assets/chars/millie/closedSmile.webp`,
        speakerTxt: `Here comes spoiler Millie, the ultimate disturbance. She is interrupting us.`,
        speakerTxtRS: `Evo je Milica, najveći smetnja. Prekida nas.`,
        dialogFx: `assets/dialog/joseph/joseph0073.mp3`
    },
    {
        speakerTxt: `"We were having coffee and talking about things we are supposed to. Writing for website, remember Millie."`,
        speakerTxtRS: `"Pili smo kafu i pričali o stvarima koje smo trebali. Pisanju za sajt, Milice."`,
        dialogFx: `assets/dialog/joseph/joseph0074.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"See you, Anna!"`,
        speakerTxtRS: `"Vidimo se, Ana!"`,
        dialogFx: `assets/dialog/millie/millie0017.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `And just like that, she disappeared the same way she appeared, in an instant.`,
        speakerTxtRS: `I tako je nestala, kao što se i pojavila, u trenu.`,
        dialogFx: `assets/dialog/joseph/joseph0075.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/office.webp`,
        characterImg: `unset`,
        speakerTxt: `After returning to the office, the only conversation we had, till end of the day, was about our website and article improvement.`,
        speakerTxtRS: `Nakon povratka u kancelariju, jedina konverzacija, do kraja dana, koju smo imali bila je o našem sajtu i poboljšanju članka.`,
        dialogFx: `assets/dialog/joseph/joseph0076.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        characterImg: `unset`,
        speakerTxt: `[After office hours ...]`,
        speakerTxtRS: `[Nakon radnog vremena ...]`
    },
    {
        backgroundImg: `assets/bgImgs/parkingLot.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"Friday, 7:00 pm?"`,
        speakerTxtRS: `"Petak, 19:00?"`,
        dialogFx: `assets/dialog/joseph/joseph0077.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"Friday, 7:00 pm it is!"`,
        speakerTxtRS: `"Petak, 19:00!"`,
        dialogFx: `assets/dialog/anna/anna0026.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        characterImg: `unset`,
        speakerName: `unset`,
        speakerTxt: `[Later that night ...]`,
        speakerTxtRS: `[Kasnije te večeri...]`
    },
    {
        backgroundImg: `assets/bgImgs/diary.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `In my heart, a door creaked open. I've been looking for someone like her for a long time. It's a stupid thing for me to want to be with her. I want to hold her. Every day, I want to wake up next to her. But I'm afraid of what's going to happen to me. I'm afraid of telling the truth. I'm afraid to tell her I really like her.`,
        speakerTxtRS: `U mom srcu su se otvorila vrata. Dugo sam tražio nekoga poput nje. Glupo je što želim da budem sa njom. Želim da je držim. Svaki dan želim da se probudim pored nje. Ali bojim se šta će mi se dogoditi. Bojim se da kažem istinu. Bojim se da joj kažem da mi se zaista sviđa.`,
        dialogFx: `assets/dialog/joseph/joseph0078.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        speakerTxt: `[Friday, 7:00pm ...]`,
        speakerTxtRS: `[Petak, 19:00 ...]`
    },
    {
        backgroundImg: `assets/bgImgs/restaurant.webp`,
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedEyesSmileCasual.webp`,
        speakerTxt: `"Hey."`,
        speakerTxtRS: `"Ćao."`,
        dialogFx: `assets/dialog/anna/anna0027.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmileCasual.webp`,
        speakerTxt: `She came first?`,
        speakerTxtRS: `Došla je prva?`,
        dialogFx: `assets/dialog/joseph/joseph0079.mp3`
    },
    {
        speakerTxt: `"Hey."`,
        speakerTxtRS: `"Ćao."`,
        dialogFx: `assets/dialog/joseph/joseph0080.mp3`
    },
    {
        speakerTxt: `"We should order seafood casserole. It's a mix of shrimp, mussels, and lobster, all in a creamy sauce."`,
        speakerTxtRS: `"Treba da naručimo morsku čorbu. To je mešavina škampa, morskih školjki i rakova, sve u krem sosu."`,
        dialogFx: `assets/dialog/joseph/joseph0081.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"That sounds delicious!"`,
        speakerTxtRS: `"Zvuči ukusno!"`,
        dialogFx: `assets/dialog/anna/anna0028.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Alright, I'll order for us."`,
        speakerTxtRS: `"U redu, naručiću nam."`,
        dialogFx: `assets/dialog/joseph/joseph0082.mp3`
    },
    {
        speakerTxt: `"So how did you end up in a this city?"`,
        speakerTxtRS: `"Kako si se našla u ovom gradu?"`,
        dialogFx: `assets/dialog/joseph/joseph0083.mp3`
    },
    {
        speakerTxt: `I am not good at conversation especially when I am the starter.`,
        speakerTxtRS: `Nisam dobar u razgovoru, posebno kada sam ja koji započinjem.`,
        dialogFx: `assets/dialog/joseph/joseph0084.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/sadCasual.webp`,
        speakerTxt: `"I don't want to bore you, Joseph."`,
        speakerTxtRS: `"Ne želim da ti dosađujem, Jožef."`,
        dialogFx: `assets/dialog/anna/anna0029.mp3`
    },
    {
        speakerName: `unset`,
        choicesBtns: [
            `Encourage her`,
            `Let it go`,
        ],
        choicesBtnsRS: [
            `Podstakni je`,
            `Odustani`,
        ],
        appendNextStoryParts: [
            [SadStory, DinnerEnding, GoodEnding],
            [LetItGo, DinnerEnding, BadEnding]
        ]
    }
];